/**
 * Job Board Page Scripts
 * Handles AJAX filtering for job board page
 */

(function() {
    'use strict';

    // Flag to prevent multiple initializations
    let isInitialized = false;

    // Wait for DOM to be ready
    function initJobBoardFilters() {
        const searchInput = document.getElementById('job-board-search');
        const stateFilter = document.getElementById('job-board-state-filter');
        const browseBtns = document.querySelectorAll('.job-board-header__browse-btn');
        const applyBtn = document.getElementById('job-board-apply-filters');
        const clearBtn = document.getElementById('job-board-clear-filters');
        const salarySlider = document.getElementById('job-board-salary-slider');
        const salaryValue = document.getElementById('job-board-salary-value');
        const resultsContainer = document.getElementById('job-board-results');
        const filterTags = document.querySelectorAll('.job-board-filters__tag');
        const filterCheckboxes = document.querySelectorAll('.job-board-filters__checkbox');

        if (!resultsContainer) {
            return; // Not on job board page
        }

        // Prevent multiple initializations
        if (isInitialized) {
            return;
        }
        isInitialized = true;

        let isLoading = false;
        const MOBILE_BREAKPOINT = 782;

        function isMobile() {
            return window.innerWidth <= MOBILE_BREAKPOINT;
        }

        const mobileFilterBtn = document.getElementById('job-board-mobile-filter-btn');
        const filterCountEl = document.getElementById('job-board-filter-count');
        const overlay = document.getElementById('job-board-filters-overlay');
        const filtersEl = document.getElementById('job-board-filters');
        const pageEl = document.querySelector('.page-job-board');

        /**
         * Initialize custom dropdown for state filter (desktop only)
         */
        function initCustomStateDropdown() {
            if (!stateFilter || isMobile()) {
                return;
            }

            const dropdownWrapper = stateFilter.closest('.job-board-header__dropdown');
            if (!dropdownWrapper) {
                return;
            }

            // Check if custom dropdown already exists to prevent duplication
            if (dropdownWrapper.querySelector('.job-board-header__custom-dropdown')) {
                return;
            }

            // Check if custom button already exists - if so, use it instead of creating new one
            let customButton = dropdownWrapper.querySelector('.job-board-header__select-custom-button');
            const buttonExists = !!customButton;

            // Create custom dropdown
            const customDropdown = document.createElement('div');
            customDropdown.className = 'job-board-header__custom-dropdown';

            // Get all options
            const options = stateFilter.querySelectorAll('option');
            options.forEach(function(option) {
                const item = document.createElement('div');
                item.className = 'job-board-header__custom-dropdown-item';
                if (option.selected) {
                    item.classList.add('job-board-header__custom-dropdown-item--selected');
                } else {
                    item.classList.add('job-board-header__custom-dropdown-item--unselected');
                }

                // Create radio button
                const radio = document.createElement('div');
                radio.className = 'job-board-header__custom-dropdown-item-radio';

                // Create text span
                const text = document.createElement('span');
                text.className = 'job-board-header__custom-dropdown-item-text';
                text.textContent = option.textContent.trim();

                // Create count badge
                const countBadge = document.createElement('span');
                countBadge.className = 'job-board-header__custom-dropdown-item-count';
                const count = option.getAttribute('data-count') || '0';
                countBadge.textContent = count;

                // Append elements
                item.appendChild(radio);
                item.appendChild(text);
                item.appendChild(countBadge);

                // Handle click
                item.addEventListener('click', function() {
                    // Update select value
                    stateFilter.value = option.value;

                    // Update visual state
                    customDropdown.querySelectorAll('.job-board-header__custom-dropdown-item').forEach(function(opt) {
                        opt.classList.remove('job-board-header__custom-dropdown-item--selected');
                        opt.classList.add('job-board-header__custom-dropdown-item--unselected');
                    });
                    item.classList.remove('job-board-header__custom-dropdown-item--unselected');
                    item.classList.add('job-board-header__custom-dropdown-item--selected');

                // Update custom button text
                const customButton = dropdownWrapper.querySelector('.job-board-header__select-custom-button');
                if (customButton) {
                    customButton.textContent = option.textContent.trim();
                }

                // Close dropdown
                customDropdown.classList.remove('job-board-header__custom-dropdown--open');
                dropdownWrapper.classList.remove('job-board-header__dropdown--open');

                // Restore sidebar sticky position
                const sidebar = document.querySelector('.page-job-board__sidebar');
                if (sidebar) {
                    sidebar.classList.remove('page-job-board__sidebar--no-sticky');
                }

                    // Trigger change event
                    const changeEvent = new Event('change', { bubbles: true });
                    stateFilter.dispatchEvent(changeEvent);
                });

                customDropdown.appendChild(item);
            });

            dropdownWrapper.appendChild(customDropdown);

            // Create custom button to replace select visually (only if it doesn't exist)
            if (!customButton) {
                customButton = document.createElement('button');
                customButton.type = 'button';
                customButton.className = 'job-board-header__select-custom-button';
                const selectedOption = stateFilter.options[stateFilter.selectedIndex];
                customButton.textContent = selectedOption ? selectedOption.textContent.trim() : '';
                customButton.setAttribute('aria-label', stateFilter.getAttribute('aria-label') || 'Select state');

                // Insert custom button right before select
                stateFilter.parentNode.insertBefore(customButton, stateFilter);
            } else {
                // Update existing button text
                const selectedOption = stateFilter.options[stateFilter.selectedIndex];
                if (selectedOption) {
                    customButton.textContent = selectedOption.textContent.trim();
                }
            }

            // Hide native select AFTER button is inserted but keep it functional
            stateFilter.classList.add('job-board-header__select--hidden');
            stateFilter.style.display = 'none';
            stateFilter.style.visibility = 'hidden';
            stateFilter.style.position = 'absolute';
            stateFilter.style.left = '-9999px';

            // Get sidebar element
            const sidebar = document.querySelector('.page-job-board__sidebar');

            // Function to toggle sidebar sticky position
            function toggleSidebarSticky(isOpen) {
                if (sidebar) {
                    if (isOpen) {
                        // Remove sticky when dropdown is open
                        sidebar.classList.add('page-job-board__sidebar--no-sticky');
                    } else {
                        // Restore sticky when dropdown is closed
                        sidebar.classList.remove('page-job-board__sidebar--no-sticky');
                    }
                }
            }

            // Handle button click
            customButton.addEventListener('click', function(e) {
                e.stopPropagation();
                const isOpen = customDropdown.classList.contains('job-board-header__custom-dropdown--open');

                // Toggle current dropdown
                if (isOpen) {
                    customDropdown.classList.remove('job-board-header__custom-dropdown--open');
                    dropdownWrapper.classList.remove('job-board-header__dropdown--open');
                    toggleSidebarSticky(false);
                } else {
                    customDropdown.classList.add('job-board-header__custom-dropdown--open');
                    dropdownWrapper.classList.add('job-board-header__dropdown--open');
                    toggleSidebarSticky(true);
                }
            });

            // Update button text when select changes
            stateFilter.addEventListener('change', function() {
                const selectedOption = stateFilter.options[stateFilter.selectedIndex];
                if (selectedOption && customButton) {
                    customButton.textContent = selectedOption.textContent.trim();
                }
            });

            // Close dropdown when clicking outside
            document.addEventListener('click', function(e) {
                if (!dropdownWrapper.contains(e.target) && !customButton.contains(e.target)) {
                    customDropdown.classList.remove('job-board-header__custom-dropdown--open');
                    dropdownWrapper.classList.remove('job-board-header__dropdown--open');

                    // Restore sidebar sticky position
                    const sidebar = document.querySelector('.page-job-board__sidebar');
                    if (sidebar) {
                        sidebar.classList.remove('page-job-board__sidebar--no-sticky');
                    }
                }
            });
        }

        // Initialize custom dropdown (desktop only)
        initCustomStateDropdown();

        // Get current filter values
        function getFilterValues() {
            const stateVals = [];
            const roleIds = [];

            if (isMobile()) {
                document.querySelectorAll('.job-board-filters__state-checkbox[data-filter-type="state"]:checked').forEach(function(cb) {
                    const v = cb.getAttribute('data-filter-value') || '';
                    if (v) stateVals.push(v);
                });
                document.querySelectorAll('.job-board-filters__role-checkbox[data-filter-type="role"]:checked').forEach(function(cb) {
                    const v = parseInt(cb.value, 10);
                    if (!isNaN(v)) roleIds.push(v);
                });
            } else {
                // Desktop: state filter is still single-select dropdown
                const stateVal = stateFilter ? stateFilter.value : '';
                if (stateVal) stateVals.push(stateVal);
                document.querySelectorAll('.job-board-filters__tag[data-filter-type="role"].job-board-filters__tag--active').forEach(function(tag) {
                    roleIds.push(parseInt(tag.dataset.filterValue, 10));
                });
            }

            const filters = {
                search: searchInput ? searchInput.value.trim() : '',
                state: stateVals,
                role: roleIds,
                salary_min: salarySlider ? parseInt(salarySlider.value, 10) : 0,
                company: [],
                employment_type: [],
                location_type: [],
            };

            document.querySelectorAll('.job-board-filters__employment-type-checkbox:checked').forEach(function(cb) {
                const v = parseInt(cb.value, 10);
                if (!isNaN(v)) filters.employment_type.push(v);
            });
            document.querySelectorAll('.job-board-filters__tag[data-filter-type="employment_type"].job-board-filters__tag--active').forEach(function(tag) {
                const v = parseInt(tag.dataset.filterValue, 10);
                if (!isNaN(v) && filters.employment_type.indexOf(v) === -1) filters.employment_type.push(v);
            });

            document.querySelectorAll('.job-board-filters__location-type-checkbox:checked').forEach(function(cb) {
                const v = parseInt(cb.value, 10);
                if (!isNaN(v)) filters.location_type.push(v);
            });
            document.querySelectorAll('.job-board-filters__tag[data-filter-type="location_type"].job-board-filters__tag--active').forEach(function(tag) {
                const v = parseInt(tag.dataset.filterValue, 10);
                if (!isNaN(v) && filters.location_type.indexOf(v) === -1) filters.location_type.push(v);
            });

            return filters;
        }

        function countActiveFilters() {
            const f = getFilterValues();
            let n = 0;
            if (f.search) n += 1;
            n += f.state.length;
            n += f.role.length;
            if (f.salary_min > 0) n += 1;
            n += f.employment_type.length;
            n += f.location_type.length;
            return n;
        }

        function updateFilterCount() {
            if (!filterCountEl) return;
            const n = countActiveFilters();
            filterCountEl.textContent = String(n);
        }

        /**
         * Update filter counts in the DOM from AJAX response (cascading counts).
         * @param {Object} filterCounts - { roles: {}, employment_types: {}, location_types: {} }
         * @param {Object} currentFilters - Current selected filter values from getFilterValues()
         */
        function updateFilterCounts(filterCounts, currentFilters) {
            if (!filterCounts) return;

            function updateFilterGroup(type, counts) {
                if (!counts || typeof counts !== 'object') return;
                const typeMap = {
                    role: 'role',
                    employment_type: 'employment_type',
                    location_type: 'location_type',
                };
                const filterType = typeMap[type];
                if (!filterType) return;

                Object.keys(counts).forEach(function(termId) {
                    const item = counts[termId];
                    const count = typeof item === 'object' && item !== null && 'count' in item ? item.count : item;
                    const numCount = parseInt(count, 10) || 0;

                    // Desktop tags
                    const tag = document.querySelector('.job-board-filters__tag[data-filter-type="' + filterType + '"][data-filter-value="' + termId + '"]');
                    if (tag) {
                        const countSpan = tag.querySelector('.job-board-filters__tag-text');
                        if (countSpan) countSpan.textContent = String(numCount);
                        tag.disabled = numCount === 0;
                        if (numCount === 0 && tag.classList.contains('job-board-filters__tag--active')) {
                            tag.classList.remove('job-board-filters__tag--active');
                        }
                    }

                    // Popup checkboxes
                    const checkboxClass = type === 'role' ? 'job-board-filters__role-checkbox' :
                        (type === 'employment_type' ? 'job-board-filters__employment-type-checkbox' : 'job-board-filters__location-type-checkbox');
                    const checkbox = document.querySelector('.' + checkboxClass + '[data-filter-value="' + termId + '"]');
                    if (checkbox) {
                        const label = checkbox.closest('label');
                        const countSpan = label ? label.querySelector('.job-board-filters__checkbox-count') : null;
                        if (countSpan) countSpan.textContent = String(numCount);
                        checkbox.disabled = numCount === 0;
                        if (numCount === 0 && checkbox.checked) {
                            checkbox.checked = false;
                        }
                    }
                });
            }

            updateFilterGroup('role', filterCounts.roles);
            updateFilterGroup('employment_type', filterCounts.employment_types);
            updateFilterGroup('location_type', filterCounts.location_types);

            // Update mobile row counts
            if (currentFilters) {
                const totalForGroup = function(counts, selectedIds) {
                    if (!counts || typeof counts !== 'object') return 0;
                    let total = 0;
                    (selectedIds || []).forEach(function(id) {
                        const key = String(id);
                        if (counts[key] && typeof counts[key] === 'object' && 'count' in counts[key]) {
                            total += parseInt(counts[key].count, 10) || 0;
                        }
                    });
                    return total;
                };

                const roleCountEl = filtersEl && filtersEl.querySelector('[data-role-count]');
                if (roleCountEl) {
                    if (currentFilters.role && currentFilters.role.length > 0) {
                        roleCountEl.textContent = totalForGroup(filterCounts.roles, currentFilters.role) + '+';
                    } else {
                        const total = filterCounts.roles ? Object.keys(filterCounts.roles).reduce(function(sum, k) {
                            const item = filterCounts.roles[k];
                            return sum + (item && item.count != null ? (parseInt(item.count, 10) || 0) : 0);
                        }, 0) : 0;
                        roleCountEl.textContent = total + '+';
                    }
                }

                const etCountEl = filtersEl && filtersEl.querySelector('[data-employment-type-count]');
                if (etCountEl) {
                    if (currentFilters.employment_type && currentFilters.employment_type.length > 0) {
                        etCountEl.textContent = totalForGroup(filterCounts.employment_types, currentFilters.employment_type) + '+';
                    } else {
                        const total = filterCounts.employment_types ? Object.keys(filterCounts.employment_types).reduce(function(sum, k) {
                            const item = filterCounts.employment_types[k];
                            return sum + (item && item.count != null ? (parseInt(item.count, 10) || 0) : 0);
                        }, 0) : 0;
                        etCountEl.textContent = total + '+';
                    }
                }

                const locCountEl = filtersEl && filtersEl.querySelector('[data-location-type-count]');
                if (locCountEl) {
                    if (currentFilters.location_type && currentFilters.location_type.length > 0) {
                        locCountEl.textContent = totalForGroup(filterCounts.location_types, currentFilters.location_type) + '+';
                    } else {
                        const total = filterCounts.location_types ? Object.keys(filterCounts.location_types).reduce(function(sum, k) {
                            const item = filterCounts.location_types[k];
                            return sum + (item && item.count != null ? (parseInt(item.count, 10) || 0) : 0);
                        }, 0) : 0;
                        locCountEl.textContent = total + '+';
                    }
                }
            }
        }

        function openFiltersModal() {
            if (!pageEl) return;
            pageEl.classList.add('page-job-board--filters-open');
            if (overlay) {
                overlay.classList.add('is-open');
                overlay.setAttribute('aria-hidden', 'false');
            }
            if (mobileFilterBtn) mobileFilterBtn.setAttribute('aria-expanded', 'true');
            document.body.style.overflow = 'hidden';
            updateFilterCount();
        }

        function closeFiltersModal() {
            if (!pageEl) return;
            closePopup('state');
            closePopup('role');
            closePopup('employment_type');
            closePopup('location_type');
            pageEl.classList.remove('page-job-board--filters-open');
            if (overlay) {
                overlay.classList.remove('is-open');
                overlay.setAttribute('aria-hidden', 'true');
            }
            if (mobileFilterBtn) mobileFilterBtn.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        }

        function openPopup(type) {
            const el = document.getElementById('job-board-popup-' + type);
            if (el) {
                el.classList.add('is-open');
                el.setAttribute('aria-hidden', 'false');
            }
        }

        function closePopup(type) {
            const el = document.getElementById('job-board-popup-' + type);
            if (el) {
                el.classList.remove('is-open');
                el.setAttribute('aria-hidden', 'true');
            }
        }

        function isPopupOpen(type) {
            const el = document.getElementById('job-board-popup-' + type);
            return el && el.classList.contains('is-open');
        }

        // Update URL with filter parameters and optional page number
        function updateURL(filters, paged) {
            const url = new URL(window.location.href);

            // Remove all filter params
            url.searchParams.delete('search');
            url.searchParams.delete('state');
            url.searchParams.delete('role');
            url.searchParams.delete('salary_min');
            url.searchParams.delete('company');
            url.searchParams.delete('employment_type');
            url.searchParams.delete('location_type');
            url.searchParams.delete('paged');

            // Add new filter params
            if (filters.search) {
                url.searchParams.set('search', filters.search);
            }
            if (filters.state.length > 0) {
                filters.state.forEach(function(stateVal) {
                    url.searchParams.append('state', stateVal);
                });
            }
            if (filters.role.length > 0) {
                filters.role.forEach(function(roleId) {
                    url.searchParams.append('role', roleId);
                });
            }
            if (filters.salary_min > 0) {
                url.searchParams.set('salary_min', filters.salary_min);
            }
            if (filters.employment_type.length > 0) {
                filters.employment_type.forEach(function(typeId) {
                    url.searchParams.append('employment_type', typeId);
                });
            }
            if (filters.location_type.length > 0) {
                filters.location_type.forEach(function(typeId) {
                    url.searchParams.append('location_type', typeId);
                });
            }
            if (paged && paged > 1) {
                url.searchParams.set('paged', String(paged));
            }

            // Update URL without reload
            window.history.pushState({}, '', url);
        }

        /**
         * Attach click handlers to job board pagination links
         */
        function attachPaginationHandlers() {
            if (!resultsContainer) return;
            const paginationLinks = resultsContainer.querySelectorAll('.job-board-pagination a');
            paginationLinks.forEach(function(link) {
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    const href = this.getAttribute('href');
                    if (!href) return;

                    let pageNumber = 1;
                    const pageMatch = href.match(/[?&]paged=(\d+)/);
                    if (pageMatch) {
                        pageNumber = parseInt(pageMatch[1], 10);
                    } else {
                        const pageMatch2 = href.match(/\/page\/(\d+)\//);
                        if (pageMatch2) {
                            pageNumber = parseInt(pageMatch2[1], 10);
                        }
                    }

                    const filters = getFilterValues();
                    updateURL(filters, pageNumber);
                    loadJobs(filters, pageNumber);

                    if (resultsContainer) {
                        resultsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });
            });
        }

        // Load jobs via AJAX
        function loadJobs(filters, paged) {
            if (isLoading) {
                return;
            }

            const pageNumber = paged && paged > 0 ? paged : 1;
            updateURL(filters, pageNumber);

            isLoading = true;
            if (resultsContainer) {
                resultsContainer.style.opacity = '0.5';
            }

            const data = {
                action: 'evona_filter_jobs',
                nonce: evona.jobFilterNonce,
                search: filters.search,
                state: filters.state,
                role: filters.role,
                salary_min: filters.salary_min,
                company: filters.company,
                employment_type: filters.employment_type,
                location_type: filters.location_type,
                paged: pageNumber,
            };

            // Use jQuery if available, otherwise use fetch
            if (typeof jQuery !== 'undefined') {
                jQuery.ajax({
                    url: evona.ajaxUrl,
                    type: 'POST',
                    data: data,
                    success: function(response) {
                        if (response.success && response.data) {
                            if (resultsContainer) {
                                resultsContainer.innerHTML = response.data.html;
                                attachPaginationHandlers();
                            }
                            if (response.data.filter_counts) {
                                try {
                                    updateFilterCounts(response.data.filter_counts, filters);
                                } catch (err) {
                                    console.warn('Job board: could not update filter counts', err);
                                }
                            }

                            // Scroll to top of results with header offset
                            if (resultsContainer) {
                                const header = document.querySelector('.header');
                                const headerHeight = header ? header.offsetHeight : 0;
                                const containerTop = resultsContainer.getBoundingClientRect().top + window.pageYOffset;
                                const offset = containerTop - headerHeight - 20; // 20px extra spacing
                                window.scrollTo({
                                    top: Math.max(0, offset),
                                    behavior: 'smooth'
                                });
                            }
                        }
                        isLoading = false;
                        if (resultsContainer) {
                            resultsContainer.style.opacity = '1';
                        }
                    },
                    error: function() {
                        isLoading = false;
                        if (resultsContainer) {
                            resultsContainer.style.opacity = '1';
                        }
                        alert('Error loading jobs. Please try again.');
                    }
                });
            } else {
                // Fallback to fetch API
                fetch(evona.ajaxUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams(data)
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(response) {
                    if (response.success && response.data) {
                        if (resultsContainer) {
                            resultsContainer.innerHTML = response.data.html;
                            attachPaginationHandlers();
                        }
                        if (response.data.filter_counts) {
                            try {
                                updateFilterCounts(response.data.filter_counts, filters);
                            } catch (err) {
                                console.warn('Job board: could not update filter counts', err);
                            }
                        }

                        // Scroll to top of results with header offset
                        if (resultsContainer) {
                            const header = document.querySelector('.header');
                            const headerHeight = header ? header.offsetHeight : 0;
                            const containerTop = resultsContainer.getBoundingClientRect().top + window.pageYOffset;
                            const offset = containerTop - headerHeight - 20; // 20px extra spacing
                            window.scrollTo({
                                top: Math.max(0, offset),
                                behavior: 'smooth'
                            });
                        }
                    }
                    isLoading = false;
                    if (resultsContainer) {
                        resultsContainer.style.opacity = '1';
                    }
                })
                .catch(function() {
                    isLoading = false;
                    if (resultsContainer) {
                        resultsContainer.style.opacity = '1';
                    }
                    alert('Error loading jobs. Please try again.');
                });
            }
        }

        // Handle filter tag clicks (only toggle, don't apply)
        filterTags.forEach(function(tag) {
            tag.addEventListener('click', function() {
                if (this.disabled) {
                    return;
                }
                this.classList.toggle('job-board-filters__tag--active');
                // Don't auto-apply - wait for button click
            });
        });

        // Handle checkbox changes (only toggle, don't apply)
        filterCheckboxes.forEach(function(checkbox) {
            checkbox.addEventListener('change', function() {
                if (this.disabled) {
                    return;
                }
                // Don't auto-apply - wait for button click
            });
        });

        /**
         * Updates the CSS variable for salary slider fill (orange portion of track).
         * @param {HTMLInputElement|null} slider - The range input element
         */
        function updateSalarySliderFill(slider) {
            if (!slider) return;
            const min = parseFloat(slider.min, 10);
            const max = parseFloat(slider.max, 10);
            const value = parseFloat(slider.value, 10);
            const percent = min === max ? 0 : ((value - min) / (max - min)) * 100;
            slider.style.setProperty('--salary-slider-percent', percent + '%');
        }

        // Handle salary slider
        if (salarySlider && salaryValue) {
            updateSalarySliderFill(salarySlider);
            salarySlider.addEventListener('input', function() {
                const value = parseInt(this.value, 10);
                salaryValue.textContent = value.toLocaleString('en-US');
                updateSalarySliderFill(salarySlider);
            });
        }

        // Mobile filter button – open modal
        if (mobileFilterBtn) {
            mobileFilterBtn.addEventListener('click', function() {
                if (!isMobile()) return;
                openFiltersModal();
            });
        }

        // Overlay click – close modal
        if (overlay) {
            overlay.addEventListener('click', closeFiltersModal);
        }

        // Close button(s) – close modal
        if (filtersEl) {
            filtersEl.addEventListener('click', function(e) {
                const btn = e.target.closest('.job-board-filters__close');
                if (!btn) return;
                closeFiltersModal();
            });
        }

        // Escape – close popup first, then modal
        document.addEventListener('keydown', function(e) {
            if (e.key !== 'Escape') return;
            if (!pageEl || !pageEl.classList.contains('page-job-board--filters-open')) return;
            const popupTypes = ['state', 'role', 'employment_type', 'location_type'];
            for (let i = 0; i < popupTypes.length; i++) {
                if (isPopupOpen(popupTypes[i])) {
                    closePopup(popupTypes[i]);
                    return;
                }
            }
            closeFiltersModal();
        });

        // Open State/Role popup (main filters)
        if (filtersEl) {
            filtersEl.addEventListener('click', function(e) {
                const row = e.target.closest('[data-open-popup]');
                if (row && row.dataset.openPopup) {
                    openPopup(row.dataset.openPopup);
                }
            });
        }

        // Popup Back – close popup, stay on main filters
        document.addEventListener('click', function(e) {
            if (!e.target.closest('[data-popup-back]')) return;
            const popup = e.target.closest('.job-board-filters-popup');
            if (!popup || !popup.id) return;
            const match = popup.id.match(/^job-board-popup-(.+)$/);
            if (match) closePopup(match[1]);
        });

        // Popup Close (X) – close popup
        document.addEventListener('click', function(e) {
            if (!e.target.closest('[data-popup-close]')) return;
            const popup = e.target.closest('.job-board-filters-popup');
            if (!popup || !popup.id) return;
            const match = popup.id.match(/^job-board-popup-(.+)$/);
            if (match) closePopup(match[1]);
        });

        // State checkboxes: multi-select (in State popup)
        // No special initialization needed - checkboxes work as multi-select by default

        // Apply changes (State popup)
        document.addEventListener('click', function(e) {
            const btn = e.target.closest('[data-apply-popup="state"]');
            if (!btn) return;
            const stateVals = [];
            const stateNames = [];
            document.querySelectorAll('.job-board-filters__state-checkbox[data-filter-type="state"]:checked').forEach(function(cb) {
                const v = cb.getAttribute('data-filter-value') || '';
                if (v) {
                    stateVals.push(v);
                    const txt = cb.closest('label');
                    if (txt) {
                        const t = txt.querySelector('.job-board-filters__checkbox-text');
                        if (t) stateNames.push(t.textContent);
                    }
                }
            });
            // Update desktop state filter (use first selected state for compatibility)
            if (stateFilter && stateVals.length > 0) {
                stateFilter.value = stateVals[0];
            } else if (stateFilter) {
                stateFilter.value = '';
            }
            // Update preview
            const preview = filtersEl && filtersEl.querySelector('[data-state-preview]');
            if (preview) {
                if (stateVals.length === 0) {
                    preview.textContent = 'Any state';
                } else {
                    preview.textContent = stateNames.slice(0, 3).join(', ') + (stateVals.length > 3 ? '…' : '');
                }
            }
            // Update count
            const countEl = filtersEl && filtersEl.querySelector('[data-state-count]');
            if (countEl) {
                if (stateVals.length > 0) {
                    let totalCount = 0;
                    document.querySelectorAll('.job-board-filters__state-checkbox[data-filter-type="state"]:checked').forEach(function(cb) {
                        const countSpan = cb.closest('label').querySelector('.job-board-filters__checkbox-count');
                        if (countSpan) {
                            totalCount += parseInt(countSpan.textContent, 10) || 0;
                        }
                    });
                    countEl.textContent = totalCount + '+';
                } else {
                    // Get total jobs count
                    const allStateCbs = document.querySelectorAll('.job-board-filters__state-checkbox[data-filter-type="state"]');
                    let totalCount = 0;
                    allStateCbs.forEach(function(cb) {
                        const countSpan = cb.closest('label').querySelector('.job-board-filters__checkbox-count');
                        if (countSpan) {
                            totalCount += parseInt(countSpan.textContent, 10) || 0;
                        }
                    });
                    countEl.textContent = totalCount + '+';
                }
            }
            closePopup('state');
            updateFilterCount();
        });

        // Apply changes (Role popup)
        document.addEventListener('click', function(e) {
            const btn = e.target.closest('[data-apply-popup="role"]');
            if (!btn) return;
            const roleIds = [];
            document.querySelectorAll('.job-board-filters__role-checkbox:checked').forEach(function(cb) {
                const v = parseInt(cb.value, 10);
                if (!isNaN(v)) roleIds.push(v);
            });
            document.querySelectorAll('.job-board-filters__tag[data-filter-type="role"]').forEach(function(tag) {
                const v = parseInt(tag.dataset.filterValue, 10);
                tag.classList.toggle('job-board-filters__tag--active', roleIds.indexOf(v) !== -1);
            });
            const preview = filtersEl && filtersEl.querySelector('[data-role-preview]');
            if (preview) {
                if (roleIds.length === 0) {
                    preview.textContent = 'Any role';
                } else {
                    const names = [];
                    document.querySelectorAll('.job-board-filters__role-checkbox:checked').forEach(function(cb) {
                        const txt = cb.closest('label');
                        if (txt) {
                            const t = txt.querySelector('.job-board-filters__checkbox-text');
                            if (t) names.push(t.textContent);
                        }
                    });
                    preview.textContent = names.slice(0, 2).join(', ') + (roleIds.length > 2 ? '…' : '');
                }
            }
            const countEl = filtersEl && filtersEl.querySelector('[data-role-count]');
            if (countEl) {
                if (roleIds.length > 0) {
                    let totalCount = 0;
                    document.querySelectorAll('.job-board-filters__role-checkbox:checked').forEach(function(cb) {
                        const countSpan = cb.closest('label').querySelector('.job-board-filters__checkbox-count');
                        if (countSpan) totalCount += parseInt(countSpan.textContent, 10) || 0;
                    });
                    countEl.textContent = totalCount + '+';
                } else {
                    let totalCount = 0;
                    document.querySelectorAll('.job-board-filters__role-checkbox').forEach(function(cb) {
                        const countSpan = cb.closest('label').querySelector('.job-board-filters__checkbox-count');
                        if (countSpan) totalCount += parseInt(countSpan.textContent, 10) || 0;
                    });
                    countEl.textContent = totalCount + '+';
                }
            }
            closePopup('role');
            updateFilterCount();
        });

        // Apply changes (Employment Type popup)
        document.addEventListener('click', function(e) {
            const btn = e.target.closest('[data-apply-popup="employment_type"]');
            if (!btn) return;
            const names = [];
            document.querySelectorAll('.job-board-filters__employment-type-checkbox:checked').forEach(function(cb) {
                const txt = cb.closest('label');
                if (txt) {
                    const t = txt.querySelector('.job-board-filters__checkbox-text');
                    if (t) names.push(t.textContent);
                }
            });
            const preview = filtersEl && filtersEl.querySelector('[data-employment-type-preview]');
            if (preview) {
                preview.textContent = names.length === 0 ? 'Any type' : names.slice(0, 3).join(', ') + (names.length > 3 ? '…' : '');
            }
            const countEl = filtersEl && filtersEl.querySelector('[data-employment-type-count]');
            if (countEl && names.length > 0) {
                let totalCount = 0;
                document.querySelectorAll('.job-board-filters__employment-type-checkbox:checked').forEach(function(cb) {
                    const countSpan = cb.closest('label').querySelector('.job-board-filters__checkbox-count');
                    if (countSpan) totalCount += parseInt(countSpan.textContent, 10) || 0;
                });
                countEl.textContent = totalCount + '+';
            } else if (countEl) {
                countEl.textContent = document.querySelectorAll('.job-board-filters__employment-type-checkbox').length ? '0+' : '0+';
            }
            closePopup('employment_type');
            updateFilterCount();
        });

        // Apply changes (Location Type popup)
        document.addEventListener('click', function(e) {
            const btn = e.target.closest('[data-apply-popup="location_type"]');
            if (!btn) return;
            const names = [];
            document.querySelectorAll('.job-board-filters__location-type-checkbox:checked').forEach(function(cb) {
                const txt = cb.closest('label');
                if (txt) {
                    const t = txt.querySelector('.job-board-filters__checkbox-text');
                    if (t) names.push(t.textContent);
                }
            });
            const preview = filtersEl && filtersEl.querySelector('[data-location-type-preview]');
            if (preview) {
                preview.textContent = names.length === 0 ? 'Any location' : names.slice(0, 3).join(', ') + (names.length > 3 ? '…' : '');
            }
            const countEl = filtersEl && filtersEl.querySelector('[data-location-type-count]');
            if (countEl && names.length > 0) {
                let totalCount = 0;
                document.querySelectorAll('.job-board-filters__location-type-checkbox:checked').forEach(function(cb) {
                    const countSpan = cb.closest('label').querySelector('.job-board-filters__checkbox-count');
                    if (countSpan) totalCount += parseInt(countSpan.textContent, 10) || 0;
                });
                countEl.textContent = totalCount + '+';
            } else if (countEl) {
                countEl.textContent = document.querySelectorAll('.job-board-filters__location-type-checkbox').length ? '0+' : '0+';
            }
            closePopup('location_type');
            updateFilterCount();
        });

        // State popup: Clear filters
        document.addEventListener('click', function(e) {
            if (!e.target.closest('[data-state-clear]')) return;
            document.querySelectorAll('.job-board-filters__state-checkbox').forEach(function(cb) {
                cb.checked = false;
            });
        });

        // Handle browse buttons (in header) - apply all filters
        browseBtns.forEach(function(browseBtn) {
            browseBtn.addEventListener('click', function() {
                const filters = getFilterValues();
                loadJobs(filters, 1);
            });
        });

        // Handle apply filters button - apply all filters
        if (applyBtn) {
            applyBtn.addEventListener('click', function() {
                const filters = getFilterValues();
                loadJobs(filters, 1);
                if (isMobile()) closeFiltersModal();
                updateFilterCount();
            });
        }

        // Handle clear filters button
        if (clearBtn) {
            clearBtn.addEventListener('click', function() {
                if (searchInput) searchInput.value = '';
                if (stateFilter) stateFilter.value = '';
                if (salarySlider) {
                    salarySlider.value = salarySlider.min;
                    if (salaryValue) salaryValue.textContent = parseInt(salarySlider.min, 10).toLocaleString('en-US');
                    updateSalarySliderFill(salarySlider);
                }
                filterTags.forEach(function(tag) {
                    tag.classList.remove('job-board-filters__tag--active');
                });
                filterCheckboxes.forEach(function(checkbox) {
                    checkbox.checked = false;
                });
                document.querySelectorAll('.job-board-filters__state-checkbox').forEach(function(cb) {
                    cb.checked = false;
                });
                document.querySelectorAll('.job-board-filters__role-checkbox').forEach(function(cb) {
                    cb.checked = false;
                });
                document.querySelectorAll('.job-board-filters__employment-type-checkbox').forEach(function(cb) {
                    cb.checked = false;
                });
                document.querySelectorAll('.job-board-filters__location-type-checkbox').forEach(function(cb) {
                    cb.checked = false;
                });
                const filters = getFilterValues();
                loadJobs(filters, 1);
                updateFilterCount();
                if (isMobile()) closeFiltersModal();
            });
        }

        // Handle search input (don't auto-apply, wait for button click)
        if (searchInput) {
            // Search input only updates value, doesn't trigger filter
            // User must click "Browse Jobs" or "Apply Filters" button
        }

        // Handle state filter change (don't auto-apply, wait for button click)
        if (stateFilter) {
            // State filter only updates value, doesn't trigger filter
            // User must click "Browse Jobs" or "Apply Filters" button
        }

        updateFilterCount();

        // Attach pagination handlers for initial server-rendered content
        attachPaginationHandlers();
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initJobBoardFilters);
    } else {
        initJobBoardFilters();
    }

    // Also initialize on window load
    if (window.addEventListener) {
        window.addEventListener('load', function() {
            setTimeout(initJobBoardFilters, 100);
        });
    }
})();
